import * as React from 'react'
import cx from 'classnames'
import { Modal } from '@local/do-secundo-modal'
import { Button, ButtonVariant } from '@local/do-secundo-button'

export interface DeleteAccountSuccessModalProps {
  testId?: string | number
  onAccept: () => void
}

export const DeleteAccountSuccessModal = ({
  onAccept,
  testId = `DeleteAccountSuccessModal`
}: DeleteAccountSuccessModalProps) => {
  return (
    <Modal
      header={
        <p className='type-default'>
          Your account has been queued to be deleted.
        </p>
      }
      responsive={false}
    >
      <div className='flex justify-end px-8 pt-8'>
        <Button
          variant={ButtonVariant.LINK}
          onClick={onAccept}
          data-testid={`${testId}-acceptance-button`}
        >
          Okay
        </Button>
      </div>
    </Modal>
  )
}
